/* Shopify owns issuance and redemption. This file never fabricates or issues codes. */
((global) => {
  'use strict';
  function validCode(value) {
    return typeof value === 'string' && value.trim().length > 0 && value.trim().length <= 255
      && !/[\u0000-\u001f\u007f]/.test(value) && !['.', '..'].includes(value.trim());
  }
  function nativeCoupons(sources, now = Date.now()) {
    const byCode = new Map();
    for (const source of Array.isArray(sources) ? sources : []) {
      const coupons = Array.isArray(source) ? source : Array.isArray(source?.coupons) ? source.coupons : [];
      for (const coupon of coupons.slice(0, 500)) {
        if (!coupon || typeof coupon !== 'object' || !validCode(coupon.code)) continue;
        const code = coupon.code.trim();
        const expiry = coupon.expiresAt == null || coupon.expiresAt === '' ? null : typeof coupon.expiresAt === 'string' ? Date.parse(coupon.expiresAt) : NaN;
        const startValue = coupon.startsAt || coupon.issuedAt;
        const start = startValue == null || startValue === '' ? null : typeof startValue === 'string' ? Date.parse(startValue) : NaN;
        const canApply = coupon.status === 'active' && (expiry === null || Number.isFinite(expiry) && expiry > now)
          && (start === null || Number.isFinite(start) && start <= now);
        const label = typeof coupon.label === 'string' && coupon.label.trim() ? coupon.label.trim().slice(0, 200) : 'Account coupon';
        const status = coupon.status === 'used' ? 'Used' : Number.isFinite(expiry) && expiry <= now ? 'Expired'
          : Number.isFinite(start) && start > now ? 'Scheduled' : canApply ? 'Saved' : 'Unavailable';
        const normalized = {...coupon, code, label, canApply, displayStatus: status, expiry};
        const key = code.toUpperCase();
        const previous = byCode.get(key);
        // Never turn a recorded used/expired code back into an available code.
        if (!previous || previous.canApply && !canApply) byCode.set(key, normalized);
      }
    }
    return [...byCode.values()];
  }
  function nativeDiscountUrl(code, rootUrl, origin) {
    if (!validCode(code)) return '';
    try {
      const site = new URL(origin);
      const root = new URL(rootUrl, site);
      if (site.protocol !== 'https:' || site.origin !== origin || root.origin !== site.origin || root.search || root.hash || !root.pathname.endsWith('/')) return '';
      const url = new URL(root.pathname + 'discount/' + encodeURIComponent(code.trim()), site);
      url.searchParams.set('redirect', root.pathname + 'cart');
      return url.href;
    } catch { return ''; }
  }
  const api = {validCode, nativeCoupons, nativeDiscountUrl};
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  global.wcfNativeCoupons = api;
  global.document?.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-wcf-coupon-copy]');
    if (!button || !validCode(button.dataset.code)) return;
    const message = button.closest('li')?.querySelector('[data-wcf-copy-status]');
    try {
      if (!global.navigator.clipboard?.writeText) throw new Error('clipboard_unavailable');
      await global.navigator.clipboard.writeText(button.dataset.code);
      if (message) message.textContent = 'Code copied. Shopify checks eligibility at checkout.';
    } catch {
      const code = button.closest('li')?.querySelector('code');
      if (code) global.getSelection()?.selectAllChildren(code);
      if (message) message.textContent = 'Select and copy the code above, or use Apply to cart.';
    }
  });
})(typeof window === 'undefined' ? globalThis : window);
